module.exports = __webpack_public_path__ + "img/teaser_training10.9b8f8139.jpg";